var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPolygonIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1.83975 5.28867L10 0.57735L18.1603 5.28867V14.7113L10 19.4227L1.83975 14.7113V5.28867Z",
  stroke: "#A4A4A4"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "white"
}))));
export { SvgPolygonIcon as ReactComponent };
export default __webpack_public_path__ + "assets/bb85f287.svg";